<script>
import autoDefaultModelMixin from '@/mixins/autoDefaultModelMixin'
import { plz } from '@/utils'

/**
 * Composant de création d'un menu en cascade
 */
export default {
  name: 'LwfSubSelect',
  mixins: [autoDefaultModelMixin],
  props: {
    value: {
      type: [Object, Number],
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    options: {
      type: Array,
      default: undefined
    }
  },
  computed: {
    reducedValue () {
      const t = this.options.reduce((r, o) => this.value && this.value[o.key] !== o.defaultValue ? r + 1 : r, 0)
      return plz(t + ' filtre', t)
    }
  },
  created () {
    const opt = {}
    this.options.forEach((o) => {
      opt[o.key] = o.defaultValue
    })
    this.$emit('input', {
      ...opt,
      ...(_.isPlainObject(this.value) ? this.value : {})
    })
  },
  methods: {
    createMenu (options, context) {
      const opt = options.map((o) => this.createMenuEntry(o, context))
      return this.$createElement(
        'q-menu',
        {
          props: context.props
        },
        [
          this.$createElement(
            'q-list',
            opt
          )
        ]
      )
    },
    createMenuEntry (option, context) {
      const children = [
        this.$createElement('q-item-section', [option.label])
      ]
      if (option.options) {
        children.push(this.$createElement(
          'q-item-section',
          { props: { side: true } },
          [this.$createElement('q-icon', { props: { name: 'fa fa-chevron-right' } })])
        )
        children.push(this.createMenu(option.options, {
          value: context.value,
          key: option.key,
          props: {
            anchor: 'top right',
            self: 'top left'
          }
        }))
      }
      return this.$createElement(
        'q-item',
        {
          props: {
            clickable: true,
            active: context.key && context.value !== undefined && context.value[context.key] === option.value
          },
          on: {
            click: () => option.value !== undefined ? this.$set(context.value, context.key, option.value) : null
          }
        },
        children
      )
    }
  },
  render (createElement) {
    const { label } = this
    return createElement(
      'q-field',
      {
        props: {
          ...this.$attrs,
          label,
          'stack-label': true,
          color: 'primary-app'
        }
      },
      [
        this.reducedValue,
        this.createMenu(this.options, this)
      ]
    )
  }
}
</script>

<style scoped>

</style>
